import React, { useState } from "react";
import "./Common_Vendor_Cards_History_Onlogin.css";
import { IDS } from "../../../utils/IDS";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

const Common_Vendor_Cards_History_Onlogin = ({ data }) => {
  const [showModal2, setShowModal2] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  console.log(data, "datadatadatadatadatadatadatadatadatadata");

  if (!data) return null;

  const handleExpandClick = () => {
    const img = data?.get_inquiry?.construction_image
      ? `${IDS.IMG_URL}${data.get_inquiry.construction_image}`
      : "/assets/images/vendors/vendor1.png";

    setSelectedImage(img);
    setShowModal2(true);
  };

  return (
    <div className="expert-list-card">
      <div className="expert-list-card__container">
        <div className="expert-list-card__image-box">
          <img
            src={`${IDS.IMG_URL}${data?.get_inquiry?.construction_image}`}
            alt={data.name}
            className="expert-list-card__img"
          />

          {data?.get_inquiry?.construction_image && (
            <div className="expant_div" onClick={handleExpandClick}>
              <FontAwesomeIcon icon={faExpand} className="exopand_text" />
            </div>
          )}
        </div>
        <div className="expert-list-card__content">
          <p className="expert-list-card__name">{data?.get_inquiry?.name}</p>

          <div className="expert-list-card__details">
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Mobile No:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.mobile_number}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Material:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.material?.name}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Sub Material:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.sub_category?.[0]?.sub_category_inquiry?.name}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Purchase Time:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.purchase_date?.name}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Description:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.description}
              </span>
            </div>
            {/* <div className="expert-list-card__row">
              <span className="expert-list-card__label">Whatsapp No:-</span>
              <span className="expert-list-card__value">
                {data.get_inquiry?.whatsapp_number || "NA"}
              </span>
            </div> */}
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">State:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.state?.name || "NA"}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">District:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.district?.name || "NA"}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Taluka:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.taluqa?.name || "NA"}
              </span>
            </div>
            <div className="expert-list-card__row">
              <span className="expert-list-card__label">Area:-</span>
              <span className="expert-list-card__value">
                {data?.get_inquiry?.area || "NA"}
              </span>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal2}
        onHide={() => setShowModal2(false)}
        centered
        size="lg"
      >
        <Modal.Body className="p-0 text-center">
          <div className="main_show_img_modal_div">
            <div className="showImg_modal">
              <img src={selectedImage} alt="Expanded" className="inner_img" />
            </div>

            <div
              className="icon_holder"
              onClick={() => {
                setShowModal2(false);
              }}
            >
              <img
                src={process.env.PUBLIC_URL + "/assets/icon/close.png"}
                className="close_img"
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Common_Vendor_Cards_History_Onlogin;
